<template>
  <div id="trivia">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <!-- <router-link to="/">
          <img
            class="pt-5 img-fluid"
            src="../assets/imgs/homecapistrano/texto-1.png"
            alt="Copa Prosa"
          />
        </router-link> -->
      </div>

      <div class=""></div>
    </section>

    <section class="pt-5">
      <div class="container pt-2">
        <div class="row pt-5">
          <div class="col-12">
            <div class="py-t justified">
              <h1 style="text-align: center" class="pb-4 azuloscuro">
                <strong>Términos y Condiciones del Servicio</strong>
              </h1>
              <p align="center">
                <strong></strong>
              </p>
              <p>Estimad@ Cliente,</p>
              <p>
                <br />
                A continuación, presentamos para su conocimiento los términos y
                condiciones de servicio de nuestras sucursales:
              </p>
              <p align="center">
                <strong>
                  La recepción de la nota o ticket de orden de servicio por
                  parte de El Cliente implica la aceptación automática de los
                  términos y condiciones de servicio descritos en estos términos
                  y condiciones.
                </strong>
              </p>
              <p align="center">
                <strong></strong>
              </p>
              <ul type="circle">
                <li>
                  Si el cliente no estuviera de acuerdo con estos términos y
                  condiciones de servicio, puede solicitar la cancelación del
                  servicio y la devolución de su dinero antes de que la prenda
                  comience a ser trabajada.
                </li>
                <li>Todo trabajo requiere el pago del 100% por anticipado.</li>
                <li>Por higiene, sólo se hacen arreglos en prendas limpias.</li>
                <li>
                  Por cuestiones de calidad y dificultad en los arreglos, no
                  todos pueden realizarse en una hora.
                </li>
                <li>
                  La garantía del servicio es de 5 días hábiles una vez
                  entregada la prenda. Para hacer efectiva la garantía, el
                  cliente debe presentar la prenda junto con la nota o ticket
                  del servicio otorgado.
                </li>
                <li>
                  Para efecto de control, sólo se entregará el total de las
                  prendas incluidas en la nota o el ticket de servicio, y no de
                  forma parcial.
                </li>
                <li>
                  El cliente debe verificar las prendas entregadas antes de
                  salir de la sucursal.
                </li>
                <li>
                  Para la entrega de prendas, en caso de no presentar la nota o
                  el ticket
                </li>
                <li>
                  original, el cliente deberá exhibir una identificación oficial
                  y/o comprobante de domicilio y firmar de recibido.
                </li>
                <li>
                  Después de 30 días a partir de la fecha de entrega, las
                  prendas que no sean recogidas se enviarán a bodega, con un
                  cargo del 2% del valor del servicio por cada día que
                  transcurra por concepto de almacenaje. Después de 90 días de
                  la fecha de entrega, la empresa podrá disponer de las prendas.
                </li>
              </ul>
              <p>
                <strong>No nos hacemos responsables por:</strong>
              </p>
              <ul type="circle">
                <li>Prendas medidas por el cliente.</li>
                <li>Prendas cortadas por el cliente.</li>
                <li>
                  Objetos y/o valores olvidados en las prendas, y/o dentro de la
                  sucursal.
                </li>
                <li>
                  El estado que guarden las prendas después de 30 días, a partir
                  de la fecha indicada para su entrega.
                </li>
              </ul>
              <p>
                <strong></strong>
              </p>
              <p>
                <strong>Políticas del Programa de Lealtad:</strong>
              </p>
              <p>
                o Para que el cliente pueda acceder al programa de lealtad debe
                proporcionar su nombre completo, número de teléfono y correo
                electrónico, e identificarse siempre con los mismos datos.
              </p>
              <ul type="circle">
                <li>
                  Se otorga al consumidor 1 punto por cada arreglo realizado.
                </li>
                <li>
                  El monto para acumular arreglos debe ser superior a $100
                  pesos.
                </li>
                <li>
                  Al acumular 10 puntos, estos podrán ser canjeados por 1
                  arreglo gratis con valor de hasta $150 pesos.
                </li>
              </ul>
              <p>
                o Los puntos no son acumulables entre cuentas con datos
                diferentes.
              </p>
              <p>
                o El programa de lealtad solo aplica en la sucursal en la que el
                cliente se registró y el servicio fue otorgado.
              </p>
              <p>
                o Para que el cliente pueda acumular arreglos, debe cubrir el
                importe total de la venta.
              </p>
              <ul type="circle">
                <li>
                  Este programa no aplica para zurcido invisible, bordados,
                  aplicaciones, etiquetas, o servicios que requieran insumos
                  especiales, etc.
                </li>
                <li>Si la nota es cancelada, ésta no acumula puntos.</li>
                <li>Los puntos no se pueden intercambiar por dinero.</li>
                <li>
                  Este programa de lealtad no aplica con otras promociones.
                </li>
                <li>
                  La sucursal podrá dar por terminado el programa de lealtad sin
                  previo aviso o por mal uso del mismo por parte del cliente.
                </li>
                <li>
                  Una vez acumulados 10 arreglos y haber realizado la redención
                  del arreglo gratis, el cliente obtiene el estatus de VIP
                  durante 1 año:
                </li>
                <ul type="circle">
                  <li>Promociones especiales</li>
                  <li>Puntos dobles</li>
                  <li>2 servicios exprés sin costo adicional</li>
                  <li>10% de descuento en los servicios del mes</li>
                </ul>
                <li>
                  La categoría de cliente VIP tiene una vigencia de 1 año a
                  partir de comenzado el estatus.
                </li>
                <li>Se otorga un punto extra por:</li>
                <ul type="circle">
                  <li>
                    Mención positiva en Google, Facebook o Instagram,
                    mostrándola a la encargada.
                  </li>
                  <li>Recomendación con código personalizado.</li>
                </ul>
              </ul>
              <p>
                <strong>Restricciones Publicidad y Promociones:</strong>
              </p>
              <ul type="circle">
                <li>Aplica fecha de vigencia.</li>
                <li>
                  La promoción es solo válida en la sucursal en la que fue
                  entregada o mencionada.
                </li>
                <li>
                  Para hacer válida la promoción, el cliente debe presentar la
                  impresión de la promoción o en su caso enseñar el medio
                  digital.
                </li>
                <li>
                  Cada promoción es independiente y no aplica con otras
                  promociones.
                </li>
                <li>Las promociones no son acumulables.</li>
                <li>Aplica solo en pago por adelantado al 100%.</li>
                <li>
                  Las tarjetas de descuento de terceros no aplican en
                  combinación con otras promociones.
                </li>
              </ul>
              <p>
                <strong>Restricciones Promoción por Apertura</strong>
              </p>
              <ul type="circle">
                <li>Aplica fecha de vigencia.</li>
                <li>La promoción es solo válida en la sucursal mencionada.</li>
                <li>
                  Para hacer válida la promoción, el cliente debe presentar la
                  impresión de la promoción o en su caso enseñar el medio
                  digital.
                </li>
                <li>
                  Cada promoción es independiente y no aplica con otras
                  promociones.
                </li>
                <li>Las promociones no son acumulables.</li>
                <li>El arreglo gratis tendrá un valor hasta de $150 pesos.</li>
              </ul>
              <ul type="circle">
                <li>Aplica solo para clientes de primera vez.</li>
                <li>
                  El arreglo gratis no aplica en servicios de bordados,
                  etiquetas, zurcido invisible, ni en arreglos que requieran de
                  un insumo adicional como telas, forros y botones especiales.
                </li>
                <li>El monto mencionado no es acumulable.</li>
                <li>La promoción se aplica en una sola exhibición.</li>
                <li>El descuento se realiza a una sola prenda.</li>
              </ul>
              <p>
                <strong>Aviso Entrega de Ticket:</strong>
              </p>
              <ul type="circle">
                <li>
                  La sucursal debe contar con energía eléctrica para la emisión
                  del ticket.
                </li>
                <li>
                  Si el equipo de cómputo se encuentra dañado o en reparación,
                  en lugar de ticket se entregará una nota foliada con los datos
                  de la sucursal.
                </li>
              </ul>
              <p>Actualización 21 agosto 2023</p>
            </div>
          </div>

          <div class="col-12 py-5"></div>
          <div class="col-12 py-5"></div>
        </div>
      </div>
    </section>

    <FooterTerminos></FooterTerminos>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import swal from "sweetalert2";

import FooterTerminos from "@/components/Footer";

export default {
  components: {
    FooterTerminos,
    SiteNav,
  },
  data() {
    return {};
  },
  computed: {
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  name: 'Términos y Condiciones',
  metaInfo: {
    title: 'Términos y Condiciones | Arréglalo', // Sets the page title
    meta: [
      {
        name: 'description',
        content: 'Conoce nuestros términos y condiciones.',
      },
    ],
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style: none;
  }
}
table {
  margin: 0 auto !important;
  border: 1px solid #afafaf;
}
</style>
